export default "__VITE_ASSET__73e39a1e__"